import { render, staticRenderFns } from "./SettingApplicantColumns.vue?vue&type=template&id=4a7ef132"
import script from "./SettingApplicantColumns.vue?vue&type=script&lang=js"
export * from "./SettingApplicantColumns.vue?vue&type=script&lang=js"
import style0 from "./SettingApplicantColumns.vue?vue&type=style&index=0&id=4a7ef132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports